import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { CardView } from 'design-system/CardView';
import SplitItem from './SplitItem';
const SplitList = ({ state, setState, onPressShowMenu, style, splitButtons, }) => {
    const onChangeText = useCallback((value, valueIndex) => {
        setState((prev) => {
            const data = prev.data.map((item, index) => index === valueIndex ? { ...item, amount: value } : item);
            const otherCents = data
                .slice(1)
                .reduce((sum, item) => sum + Math.round(item.amount * 100), 0);
            const firstCents = Math.round(Math.abs(prev.originalAmount) * 100) - otherCents;
            data[0] = { ...data[0], amount: Math.max(firstCents, 0) / 100 };
            return { ...prev, data };
        });
    }, [setState]);
    const renderItem = useCallback((item, index) => (<SplitItem maxAmount={state.originalAmount} key={item.id.toString()} currency={item.currency} amount={item.amount} onChangeText={onChangeText} id={index} onPressShowMenu={onPressShowMenu} category={item.category} animate={index > 1}/>), [onChangeText, onPressShowMenu, state.originalAmount]);
    const { data } = state;
    return (<View style={style}>
      <CardView noMarginTop>
        {data.map((item, index) => renderItem(item, index))}
        {splitButtons}
      </CardView>
    </View>);
};
export default memo(SplitList);
